var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCopySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3031_2866",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "black",
    fillOpacity: 0.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3031_2866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 15.3333C1.96667 15.3333 1.65278 15.2028 1.39167 14.9417C1.13056 14.6805 1 14.3667 1 14V4.66666H2.33333V14H9.66667V15.3333H2.33333ZM5 12.6667C4.63333 12.6667 4.31944 12.5361 4.05833 12.275C3.79722 12.0139 3.66667 11.7 3.66667 11.3333V1.99999C3.66667 1.63332 3.79722 1.31943 4.05833 1.05832C4.31944 0.797212 4.63333 0.666656 5 0.666656H9.66667L13.6667 4.66666V11.3333C13.6667 11.7 13.5361 12.0139 13.275 12.275C13.0139 12.5361 12.7 12.6667 12.3333 12.6667H5ZM9 5.33332H12.3333L9 1.99999V5.33332Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopySelected);
export default __webpack_public_path__ + "static/media/file_copy_selected.3de24fae9de825221aafbcb53d2ccd9d.svg";
export { ForwardRef as ReactComponent };